import { createFileRoute } from '@tanstack/react-router'

import { PayoutsPage } from '@/pages/payouts/payouts-page'

export const Route = createFileRoute('/_private/payouts')({
  component: PayoutsPage,
})
